import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ConvenienceTable from './ConvenienceTable';
import TermTable from './TermTable';
import PrefilledTable from './PrefilledTable';
import EditConvenienceFee from './EditConvenienceFee';
import EditPrefilled from './EditPrefilled';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { _axios } from '../../utils/axios';

const Configurations = () => {
    const [termsContent, setTermsContent] = useState('');
    const [termsContentHin, setTermsContentHin] = useState('');
    const [termsContentMar, setTermsContentMar] = useState('');
    const [termsContentGuj, setTermsContentGuj] = useState('');
    const [isLoadingTerms, setIsLoadingTerms] = useState(false);
    const [termsError, setTermsError] = useState(null);
    const [showAuditHistory, setShowAuditHistory] = useState(false);
    const [showVersionHistory, setShowVersionHistory] = useState(false);
    const [showPrefilledHistory, setShowPrefilledHistory] = useState(false);
    const [showEditFee, setShowEditFee] = useState(false);
    const [showEditTerms, setShowEditTerms] = useState(false);
    const [showEditPrefilled, setShowEditPrefilled] = useState(false);
    const [showTermsHistory, setShowTermsHistory] = useState(false);
    const [language, setLanguage] = useState('en');
    const [convenienceData, setConvenienceData] = useState({
        convenience_fee_amount: '',
        min_amount: '',
        convenience_increment: '',
        fee_type: 'PERCENTAGE',
        default_percentage: null,
        fee_id: 1
    });
    const [slabs, setSlabs] = useState([]);

    const [prefilledData, setPrefilledData] = useState({
        prefilled_amount: ''
    });

    const loadSlabs = async (feeId) => {
        try {
            const res = await _axios.get(`${ServerPath}/convenience-fee/slabs`, { params: { fee_id: feeId } });
            if (res.data?.success === 1) {
                const sorted = (res.data.data || []).slice().sort(
                    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
                );
                setSlabs(sorted);
            }
        } catch (err) {
            console.error('Error fetching slabs:', err);
        }
    };

    useEffect(() => {
        const fetchConvenienceData = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/convenience-fee/get`);
                if (response.data?.success === 1 && response.data?.data?.length > 0) {
                    const latestFee = response.data.data[0];
                    const feeId = latestFee.fee_id ?? 1;
                    setConvenienceData({
                        convenience_fee_amount: latestFee.convenience_fee_amount,
                        min_amount: latestFee.min_amount,
                        convenience_increment: latestFee.convenience_increment,
                        fee_type: latestFee.fee_type || 'PERCENTAGE',
                        default_percentage: latestFee.default_percentage,
                        fee_id: feeId
                    });
                    if ((latestFee.fee_type || 'PERCENTAGE') === 'FIXED_SLAB') {
                        loadSlabs(feeId);
                    }
                }
            } catch (err) {
                console.error('Error fetching convenience fee data:', err);
            }
        };

        fetchConvenienceData();
    }, []);

    useEffect(() => {
        const fetchTermsData = async () => {
            setIsLoadingTerms(true);
            setTermsError(null);

            try {
                const response = await _axios.get(`${ServerPath}/donation-term-conditions/latest`);
                if (response.data?.data?.donation_term_details) {
                    setTermsContent(response.data.data.donation_term_details);
                } else {
                    setTermsError('Terms content not available');
                }
                if(response.data?.data?.donation_term_details_hin) {
                    setTermsContentHin(response.data.data.donation_term_details_hin);
                }
                if(response.data?.data?.donation_term_details_guj) {
                    setTermsContentGuj(response.data.data.donation_term_details_guj);
                }
                if(response.data?.data?.donation_term_details_mar) {
                    setTermsContentMar(response.data.data.donation_term_details_mar);
                }
            } catch (err) {
                console.error('Error fetching terms data:', err);
                setTermsError('Failed to load terms and conditions');
            } finally {
                setIsLoadingTerms(false);
            }
        };

        fetchTermsData();
    }, []);

    useEffect(() => {
        const fetchPrefilledData = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/prefilled-details/get`);
                if (response.data?.success === 1 && response.data?.data?.length > 0) {
                    const latestAmount = response.data.data[0];
                    setPrefilledData({
                        prefilled_amount: latestAmount.prefilled_amount
                    });
                }
            } catch (err) {
                console.error('Error fetching prefilled amount data:', err);
            }
        };

        fetchPrefilledData();
    }, []);

    const refreshConvenienceData = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/convenience-fee/get`);
            if (response.data?.success === 1 && response.data?.data?.length > 0) {
                const latestFee = response.data.data[0];
                const feeId = latestFee.fee_id ?? 1;
                setConvenienceData({
                    convenience_fee_amount: latestFee.convenience_fee_amount,
                    min_amount: latestFee.min_amount,
                    convenience_increment: latestFee.convenience_increment,
                    fee_type: latestFee.fee_type || 'PERCENTAGE',
                    default_percentage: latestFee.default_percentage,
                    fee_id: feeId
                });
                if ((latestFee.fee_type || 'PERCENTAGE') === 'FIXED_SLAB') {
                    loadSlabs(feeId);
                } else {
                    setSlabs([]);
                }
            }
        } catch (err) {
            console.error('Error fetching convenience fee data:', err);
        }
    };

    const refreshPrefilledData = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/prefilled-details/get`);
            if (response.data?.success === 1 && response.data?.data?.length > 0) {
                const latestAmount = response.data.data[0];
                setPrefilledData({
                    prefilled_amount: latestAmount.prefilled_amount
                });
            }
        } catch (err) {
            console.error('Error fetching prefilled amount data:', err);
        }
    };

    return (
        <Container fluid className="p-3">
            <h5 className="mb-4" style={{ marginTop: '-10px' }}>Configurations</h5>

            {/* First Row with Two Sections */}
            <Row className='gy-4'>
                <Col lg={6}>
                    {/* Convenience Fee Management Section */}
                    <div className="bg-white rounded-4 p-4 h-100">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h5 className="text-black fs-8">Convenience fee management</h5>
                            <Button
                                variant="warning"
                                className="border-0 px-4 rounded-3 text-white"
                                onClick={() => setShowAuditHistory(true)}
                            >
                                Audit History
                            </Button>
                        </div>

                        <Form>
                            <Row className="mb-3">
                                <Col md={5}>
                                    <Form.Label className="text-secondary fw-semibold">
                                        Convenience Fee Type
                                    </Form.Label>
                                    <div className="d-flex flex-column gap-2 mt-1">
                                        <Form.Check
                                            type="radio"
                                            label="Percentage"
                                            name="cfg-fee-type-readonly"
                                            checked={convenienceData.fee_type === 'PERCENTAGE'}
                                            readOnly
                                            disabled
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Fixed Amount Slab"
                                            name="cfg-fee-type-readonly"
                                            checked={convenienceData.fee_type === 'FIXED_SLAB'}
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                </Col>
                                <Col md={7}>
                                    {convenienceData.fee_type === 'PERCENTAGE' ? (
                                        <Form.Group>
                                            <Form.Label className="text-secondary">
                                                Default Percentage <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={
                                                    convenienceData.default_percentage != null
                                                        ? `${convenienceData.default_percentage}%`
                                                        : ''
                                                }
                                                className="bg-light rounded-3 p-2"
                                                readOnly
                                            />
                                        </Form.Group>
                                    ) : (
                                        <div>
                                            <Form.Label className="text-secondary fw-semibold mb-2">
                                                Slab Configuration
                                            </Form.Label>
                                            {slabs.length === 0 ? (
                                                <div className="text-muted small">No slabs configured</div>
                                            ) : (
                                                <div
                                                    className="border rounded p-2"
                                                    style={{ maxHeight: 160, overflowY: 'auto', background: '#fafafa' }}
                                                >
                                                    <Row className="small fw-semibold text-secondary mb-1">
                                                        <Col xs={4}>Min</Col>
                                                        <Col xs={4}>Max</Col>
                                                        <Col xs={4}>Fee</Col>
                                                    </Row>
                                                    {slabs.map(s => (
                                                        <Row key={s.slab_id} className="small mb-1">
                                                            <Col xs={4}>₹ {s.min_amount}</Col>
                                                            <Col xs={4}>{s.max_amount == null ? 'Open' : `₹ ${s.max_amount}`}</Col>
                                                            <Col xs={4}>₹ {s.fee_amount}</Col>
                                                        </Row>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-end">
                                <Button
                                    variant="primary"
                                    className="px-5 py-2 rounded-3"
                                    style={{ backgroundColor: '#6366F1' }}
                                    onClick={() => setShowEditFee(true)}
                                >
                                    Edit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col lg={6}>
                    {/* Prefilled Amount Section */}
                    <div className="bg-white rounded-4 p-4 h-100">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h5 className="text-black fs-5">Prefilled Amount</h5>
                            <Button
                                variant="warning"
                                className="border-0 px-4 rounded-3 text-white"
                                onClick={() => setShowPrefilledHistory(true)}
                            >
                                Audit History
                            </Button>
                        </div>

                        <Form>
                            <Row className="mb-4">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="text-secondary">
                                            Amount <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={`₹ ${prefilledData.prefilled_amount || ''}`}
                                            className="bg-white rounded-3 p-2"
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-end" style={{ marginTop: '90px' }}>
                                <Button
                                    variant="primary"
                                    className="px-5 py-2 rounded-3"
                                    style={{ backgroundColor: '#6366F1' }}
                                    onClick={() => setShowEditPrefilled(true)}
                                >
                                    Edit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>

                
            </Row>

            {/* Second Row */}
            <Row className='gy-4 mt-1 '>
                <Col lg={6}>
                    {/* Terms and Conditions Management Section */}
                    <div className="bg-white rounded-4 p-4 h-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="text-black fs-5">Terms and Conditions English</h5>
                            <Button
                                variant="warning"
                                className="border-0 px-4 rounded-3 text-white"
                                onClick={() => {setLanguage('en');setShowTermsHistory(true)}}
                            >
                                Version History
                            </Button>
                        </div>

                        <Form>
                            <div className="bg-white p-2 rounded mb-4 custom-scrollbar" 
                                 style={{ maxHeight: '170px', height: '170px', overflowY: 'auto', border: '1px solid #ccc', position: 'relative' }}>
                                {isLoadingTerms ? (
                                    <p className="text-center">Loading terms and conditions...</p>
                                ) : termsError ? (
                                    <p className="text-danger">{termsError}</p>
                                ) : (
                                    <>
                                        <style>
                                            {`
                                                .terms-content {
                                                    color: #000 !important;
                                                    padding-right: 16px !important;
                                                }
                                                .terms-content .para-text,
                                                .terms-content .small-title-dark,
                                                .terms-content ul li {
                                                    color: #000 !important;
                                                }
                                                .terms-content strong {
                                                    color: #000 !important;
                                                    font-weight: 600;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar {
                                                    width: 8px !important;
                                                    background-color: #f1f1f1 !important;
                                                    padding: 10px !important 
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-track {
                                                    background: #f1f1f1;
                                                    border-radius: 10px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                                    background: #5C61F2 !important;
                                                    border-radius: 10px !important;
                                                    border: 2px solid #f1f1f1 !important;
                                                    height: 40px !important;
                                                    min-height: 40px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                                    background-color: #5C61F2;
                                                }   
                                            `}
                                        </style>
                                        <div
                                            className="terms-content"
                                            dangerouslySetInnerHTML={{
                                                __html: termsContent
                                                    .replace(/<head>[\s\S]*?<\/head>/gi, '')
                                                    .replace(/<html>|<\/html>|<body>|<\/body>|<!DOCTYPE html>/gi, '')
                                                    .replace(/<div class="container pt-4">/i, '<div>')
                                            }}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="d-flex justify-content-end" style={{ marginTop: '-15px' }}>
                                <Button
                                    variant="primary"
                                    className="px-5 py-2 rounded-3"
                                    style={{ backgroundColor: '#6366F1' }}
                                    onClick={() => {setLanguage('en');setShowEditTerms(true)}}
                                >
                                    Edit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col lg={6}>
                    {/* Terms and Conditions Management Section */}
                    <div className="bg-white rounded-4 p-4 h-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="text-black fs-5">Terms and Conditions Hindi</h5>
                            <Button
                                variant="warning"
                                className="border-0 px-4 rounded-3 text-white"
                                onClick={() => {setLanguage('hi');setShowTermsHistory(true)}}
                            >
                                Version History
                            </Button>
                        </div>

                        <Form>
                            <div className="bg-white p-2 rounded mb-4 custom-scrollbar" 
                                 style={{ maxHeight: '170px', height: '170px', overflowY: 'auto', border: '1px solid #ccc', position: 'relative' }}>
                                {isLoadingTerms ? (
                                    <p className="text-center">Loading terms and conditions...</p>
                                ) : termsError ? (
                                    <p className="text-danger">{termsError}</p>
                                ) : (
                                    <>
                                        <style>
                                            {`
                                                .terms-content {
                                                    color: #000 !important;
                                                    padding-right: 16px !important;
                                                }
                                                .terms-content .para-text,
                                                .terms-content .small-title-dark,
                                                .terms-content ul li {
                                                    color: #000 !important;
                                                }
                                                .terms-content strong {
                                                    color: #000 !important;
                                                    font-weight: 600;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar {
                                                    width: 8px !important;
                                                    background-color: #f1f1f1 !important;
                                                    padding: 10px !important 
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-track {
                                                    background: #f1f1f1;
                                                    border-radius: 10px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                                    background: #5C61F2 !important;
                                                    border-radius: 10px !important;
                                                    border: 2px solid #f1f1f1 !important;
                                                    height: 40px !important;
                                                    min-height: 40px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                                    background-color: #5C61F2;
                                                }   
                                            `}
                                        </style>
                                        <div
                                            className="terms-content"
                                            dangerouslySetInnerHTML={{
                                                __html: termsContentHin
                                                    .replace(/<head>[\s\S]*?<\/head>/gi, '')
                                                    .replace(/<html>|<\/html>|<body>|<\/body>|<!DOCTYPE html>/gi, '')
                                                    .replace(/<div class="container pt-4">/i, '<div>')
                                            }}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="d-flex justify-content-end" style={{ marginTop: '-15px' }}>
                                <Button
                                    variant="primary"
                                    className="px-5 py-2 rounded-3"
                                    style={{ backgroundColor: '#6366F1' }}
                                    onClick={() => {setLanguage('hi');setShowEditTerms(true)}}
                                >
                                    Edit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>

             <Row className='gy-4 mt-1 '>
                <Col lg={6}>
                    {/* Terms and Conditions Management Section */}
                    <div className="bg-white rounded-4 p-4 h-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="text-black fs-5">Terms and Conditions Marathi</h5>
                            <Button
                                variant="warning"
                                className="border-0 px-4 rounded-3 text-white"
                                onClick={() => {setLanguage('mr');setShowTermsHistory(true)}}
                            >
                                Version History
                            </Button>
                        </div>

                        <Form>
                            <div className="bg-white p-2 rounded mb-4 custom-scrollbar" 
                                 style={{ maxHeight: '170px', height: '170px', overflowY: 'auto', border: '1px solid #ccc', position: 'relative' }}>
                                {isLoadingTerms ? (
                                    <p className="text-center">Loading terms and conditions...</p>
                                ) : termsError ? (
                                    <p className="text-danger">{termsError}</p>
                                ) : (
                                    <>
                                        <style>
                                            {`
                                                .terms-content {
                                                    color: #000 !important;
                                                    padding-right: 16px !important;
                                                }
                                                .terms-content .para-text,
                                                .terms-content .small-title-dark,
                                                .terms-content ul li {
                                                    color: #000 !important;
                                                }
                                                .terms-content strong {
                                                    color: #000 !important;
                                                    font-weight: 600;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar {
                                                    width: 8px !important;
                                                    background-color: #f1f1f1 !important;
                                                    padding: 10px !important 
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-track {
                                                    background: #f1f1f1;
                                                    border-radius: 10px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                                    background: #5C61F2 !important;
                                                    border-radius: 10px !important;
                                                    border: 2px solid #f1f1f1 !important;
                                                    height: 40px !important;
                                                    min-height: 40px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                                    background-color: #5C61F2;
                                                }   
                                            `}
                                        </style>
                                        <div
                                            className="terms-content"
                                            dangerouslySetInnerHTML={{
                                                __html: termsContentMar
                                                    .replace(/<head>[\s\S]*?<\/head>/gi, '')
                                                    .replace(/<html>|<\/html>|<body>|<\/body>|<!DOCTYPE html>/gi, '')
                                                    .replace(/<div class="container pt-4">/i, '<div>')
                                            }}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="d-flex justify-content-end" style={{ marginTop: '-15px' }}>
                                <Button
                                    variant="primary"
                                    className="px-5 py-2 rounded-3"
                                    style={{ backgroundColor: '#6366F1' }}
                                    onClick={() => {setLanguage('mr');setShowEditTerms(true)}}
                                >
                                    Edit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col lg={6}>
                    {/* Terms and Conditions Management Section */}
                    <div className="bg-white rounded-4 p-4 h-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="text-black fs-5">Terms and Conditions Gujrati</h5>
                            <Button
                                variant="warning"
                                className="border-0 px-4 rounded-3 text-white"
                                onClick={() => {setLanguage('gu');setShowTermsHistory(true)}}
                            >
                                Version History
                            </Button>
                        </div>

                        <Form>
                            <div className="bg-white p-2 rounded mb-4 custom-scrollbar" 
                                 style={{ maxHeight: '170px', height: '170px', overflowY: 'auto', border: '1px solid #ccc', position: 'relative' }}>
                                {isLoadingTerms ? (
                                    <p className="text-center">Loading terms and conditions...</p>
                                ) : termsError ? (
                                    <p className="text-danger">{termsError}</p>
                                ) : (
                                    <>
                                        <style>
                                            {`
                                                .terms-content {
                                                    color: #000 !important;
                                                    padding-right: 16px !important;
                                                }
                                                .terms-content .para-text,
                                                .terms-content .small-title-dark,
                                                .terms-content ul li {
                                                    color: #000 !important;
                                                }
                                                .terms-content strong {
                                                    color: #000 !important;
                                                    font-weight: 600;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar {
                                                    width: 8px !important;
                                                    background-color: #f1f1f1 !important;
                                                    padding: 10px !important 
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-track {
                                                    background: #f1f1f1;
                                                    border-radius: 10px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                                    background: #5C61F2 !important;
                                                    border-radius: 10px !important;
                                                    border: 2px solid #f1f1f1 !important;
                                                    height: 40px !important;
                                                    min-height: 40px !important;
                                                }
                                                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                                    background-color: #5C61F2;
                                                }   
                                            `}
                                        </style>
                                        <div
                                            className="terms-content"
                                            dangerouslySetInnerHTML={{
                                                __html: termsContentGuj
                                                    .replace(/<head>[\s\S]*?<\/head>/gi, '')
                                                    .replace(/<html>|<\/html>|<body>|<\/body>|<!DOCTYPE html>/gi, '')
                                                    .replace(/<div class="container pt-4">/i, '<div>')
                                            }}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="d-flex justify-content-end" style={{ marginTop: '-15px' }}>
                                <Button
                                    variant="primary"
                                    className="px-5 py-2 rounded-3"
                                    style={{ backgroundColor: '#6366F1' }}
                                    onClick={() => {setLanguage('gu');setShowEditTerms(true)}}
                                >
                                    Edit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>

            {/* Modals and Tables */}
            <ConvenienceTable
                show={showAuditHistory}
                handleClose={() => setShowAuditHistory(false)}
            />
            <TermTable
                show={showEditTerms}
                handleClose={() => setShowEditTerms(false)}
                initialShowHistory={false}
                initialContent={termsContent}
                language={language}
            />
            <TermTable
                show={showTermsHistory}
                handleClose={() => setShowTermsHistory(false)}
                initialShowHistory={true}
                initialContent={termsContent}
                language={language}
            />
            <PrefilledTable
                show={showPrefilledHistory}
                handleClose={() => setShowPrefilledHistory(false)}
            />
            <EditConvenienceFee
                show={showEditFee}
                handleClose={() => setShowEditFee(false)}
                feeId={convenienceData.fee_id}
                currentFeeType={convenienceData.fee_type}
                currentDefaultPercentage={convenienceData.default_percentage}
                currentSlabs={slabs}
                onUpdateSuccess={refreshConvenienceData}
            />
            <EditPrefilled
                show={showEditPrefilled}
                handleClose={() => setShowEditPrefilled(false)}
                currentAmount={prefilledData.prefilled_amount}
                onUpdateSuccess={refreshPrefilledData}
            />
        </Container>
    );
};

export default Configurations;